import {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {closeModal, updateModal, verifyFacebookStory} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation';

export default ({modal, data}) => {
    const dispatch = useDispatch(),
          ref = useRef();

    return (
        <>
            <div className="creative-header" style={{
                background: `url(${window.location.origin}/source/modules/modals/facebook-post/share.png)`,
                backgroundSize: 'cover'
            }}>
                <div className="close dark" onClick={e => dispatch(closeModal())}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 18L18 6" stroke="#161C2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="#161C2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div className="modal-text" style={{marginTop: '-30px'}}>
                <div className="title">Verify Your Profile</div>
                <div className="description" style={{textAlign: "center", width: "80%"}}>Make sure your Facebook profile is <u>public and has 20+ friends.</u></div>
            </div>

            <div className="modal-copy-block">
                <div className="label">Profile link</div>
                <div className="input" onClick={e => {
                    if(ref.current)
                        ref.current.focus();
                }}>
                    <input
                        type="text"
                        placeholder="Paste your profile link"
                        ref={ref}
                        onInput={e => {
                            dispatch(updateModal('facebook_story', {
                                verify: {
                                    url: e.target.value
                                }
                            }))
                        }} />
                </div>
            </div>

            <div className="block">
                <div style={{
                    opacity: data.url.length < 10 || data.button ? 0.7 : 1,
                    cursor: data.url.length < 10 || data.button ? 'no-drop' : 'pointer',
                }} className="modal-button blue" onClick={e => {
                    if(data.url.length < 10 || data.button)
                        return;

                    dispatch(verifyFacebookStory(data));
                }}>
                    Verify & Get Bonus
                </div>
            </div>
        </>
    )
} 